// Stub - not linked yet
export const MultiVariantPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Multi-Variant Templates
        </h1>
        <p className="text-gray-600">Coming soon</p>
      </div>
    </div>
  );
};
